var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToMenuUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gotomenuUnderline_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.96 3.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .gotomenuUnderline-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gotomenuUnderline_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gotomenuUnderline-1",
    d: "M0,0c35.46,4.28,71.46,4.45,106.96.53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToMenuUnderline);
export default __webpack_public_path__ + "static/media/GoToMenu Underline.2d735cfef1bfc38dd4942042243656fc.svg";
export { ForwardRef as ReactComponent };